'use client';

import { useScroll, useTransform, motion, cubicBezier } from 'framer-motion';
import { Session } from 'next-auth';
import useCartStore from '@/lib/state-stores/cartStore';
import { ShoppingBagIcon } from 'lucide-react';
import SlideUpAnimation from './SlideUpAnimation';

interface ScrollVisibilityComponentProps {
  session: Session;
}

const ScrollVisibilityComponent = ({ session }: ScrollVisibilityComponentProps) => {
  const { carts } = useCartStore();

  const { scrollY } = useScroll();
  const opacity = useTransform(scrollY, [0, 100], [0, 1], {
    ease: cubicBezier(0.17, 0.67, 0.83, 0.67),
  });
  const pointerEvents = useTransform(opacity, (value) => (value === 1 ? 'auto' : 'none'));
  const y = useTransform(scrollY, [0, 100], [0, -10], {
    ease: cubicBezier(0.17, 0.67, 0.83, 0.67),
  });

  return (
    <motion.div
      style={{ opacity, pointerEvents, y }}
      className={`bg-primary fixed right-3 bottom-20 z-50 grid h-12 w-12 cursor-pointer place-items-center rounded-full lg:bottom-[11dvh] lg:left-8 lg:h-16 lg:w-16`}
    >
      <div className="relative">
        <ShoppingBagIcon className="h-5 w-5 cursor-pointer text-white lg:h-7 lg:w-7" />
        {session?.user && carts.length ? (
          <div
            className={`centerButton absolute top-[-50%] left-[50%] grid aspect-square min-w-6 place-items-center rounded-full bg-red-500 text-xs text-white`}
          >
            <SlideUpAnimation uniqueKey={carts.length}>{carts.length}</SlideUpAnimation>
          </div>
        ) : null}
      </div>
    </motion.div>
  );
};

export default ScrollVisibilityComponent;
